module.exports = __webpack_public_path__ + "files/26f776daf9bbb687ed0dcc2a21aa73e9.png";